/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Row, Col } from "react-awesome-styled-grid";
import { If, Then, Else } from "react-if";
import { BreadcrumbsBox } from "~/components";
import { useBillingPeriod } from "~/services/customers";
import { ReservationsCommitmentsAccessHandler } from "~/views/reservedInstances/components";
import { ReservationBanner } from "../components/ReservationBanner";
import {
  breadcrumbLabelsAzureRI,
  RESERVATION_BANNER_DEFAULT_PROPS,
} from "../constants";
import { AzureCurrentBillingPeriodPage } from "./AzureCurrentBillingPeriodPage";

export function AzureReservationsCommitmentsPage() {
  const { activateCurrentBillingPeriod, isCurrentBillingPeriod } =
    useBillingPeriod();

  return (
    <ReservationsCommitmentsAccessHandler accessTo="azure">
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Reservations - Azure"
            labels={breadcrumbLabelsAzureRI}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <If condition={isCurrentBillingPeriod}>
            <Then>
              <AzureCurrentBillingPeriodPage />
            </Then>
            <Else>
              <ReservationBanner
                onClick={activateCurrentBillingPeriod}
                {...RESERVATION_BANNER_DEFAULT_PROPS}
              />
            </Else>
          </If>
        </Col>
      </Row>
    </ReservationsCommitmentsAccessHandler>
  );
}
